import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import '@/styles/index.less';
import App from './App.tsx';
import {initAntiCheatWhenIdle} from '@/services/antiCheat';
import {initLog} from '@/services/tracking';
import {installEarlyErrorCapture, scheduleWeirwoodInit} from '@/logger/weirwood';

dayjs.locale('zh-cn');
initAntiCheatWhenIdle();
initLog({
    page: 'home',
    testMode: import.meta.env.VITE_UBC_TEST_MODE === 'true',
});
try {
    installEarlyErrorCapture();
    scheduleWeirwoodInit();
} catch {}

const rootElement = document.getElementById('root');
if (rootElement) {
    createRoot(rootElement).render(
        <StrictMode>
            <App />
        </StrictMode>,
    );
}
